import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { UserPreferenceService } from "./user-preference.service";

/**
 * Forces a fresh preferences fetch before the Settings route activates, so the page
 * never renders stale/default values that pop in once the request resolves.
 */
export const userPreferenceResolver: ResolveFn<void> = () => {
    return inject(UserPreferenceService)
        .refresh()
        .then(() => void 0);
};
